import UiForm from "./UiForm";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import UiGroup from "./UiGroup";

/**
 * 
 * @description 自动生成的代码,请勿修改
 */
export default class DtoPutCustomsCode extends UiForm<string> {
    constructor() {
        //无参构造函数
        super()
        this.UiGroups = [];
    }

    [proName: string]: any;
    /**
     * 报关单号
     */
    CustomsCode?: string;
}

/**
 * -表单校验
 */
export const DtoPutCustomsCodeRules = {
}

/**
 * -设置项
 */
export const DtoPutCustomsCodeMiezzFormItems: MiezzFormItem[] = [
  {
    Prop: "CustomsCode",
    Label: "报关单号",
    Type: EnumMiezzFormItemType.InputText,
  },
]
